/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { Component, ReactElement } from 'react';
import style from './index.module.css';
import ReactDOM from 'react-dom';
import { getPlatform } from '../../utils/common';
interface Props {
  visible: boolean;
  text: string;
}

export function Content(props: Props) {
  const { visible, text } = props;
  const touchMoveStart = (e)=>{
    if(getPlatform()==='iOS'){
      e.preventDefault()
    }
  }
  return visible ? (
    <div className={style.wrap} onTouchStart={touchMoveStart}>
      <div className={style.shell}>
        <div className={style.content}>{text}</div>
      </div>
    </div>
  ) : null;
}

export interface ToastOpts {
  text: string;
  duration?: number;
  cbk?: Function;
}
//暂时没有props，先预留位置
interface ToastProps {
  container: HTMLElement;
  text: string;
  [x: string]: any;
}
export default class Toast extends Component<ToastProps, {}> {
  static _container: HTMLElement | null;
  static _timer: number = 0;
  static _opt: ToastOpts;
  static show = function(opt: ToastOpts) {
    Toast._opt = opt;
    if (Toast._container) return;
    const div = document.createElement('div');
    document.body.appendChild(div);
    Toast._container = div;
    ReactDOM.render(<Toast container={div} text={opt.text} />, div);
    if (opt.duration) {
      Toast._timer = window.setTimeout(() => {
        Toast.hide();
      }, opt.duration);
    }
  };
  static hide = function() {
    if (Toast._container) {
      const div = Toast._container;
      const unmountRes = ReactDOM.unmountComponentAtNode(div);
      if (unmountRes && div.parentNode) {
        div.parentNode.removeChild(div);
        if (Toast._opt.cbk) {
          Toast._opt.cbk();
        }
      }
    }
    Toast._container = null;
  };

  render(): ReactElement {
    return ReactDOM.createPortal(
      <Content visible={true} text={this.props.text} />,
      this.props.container
    );
  }
}
